import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit';
import visitorsHistoryReducer from './chatHistorySlice';
import clientsReducer from './clientsSlice';
import colorSchemeReducer from './colorSchemeSlice';
import compactMenuReducer from './compactMenuSlice';
import controlCentreSliceReducer from './controlCentreSlice';
import clarionCallsReducer from './clarionCallsSlice';
import atlasSummaryReducer from './atlasSummarySlice';
import darkModeReducer from './darkModeSlice';
import generalFilterReducer from './generalFilterSlice';
import leadsReducer from './leadsSlice';
import leadsStatReducer from './leadsStatsSlice';
import fetchEnquiryTourReducer from './enquiryToursSlice';
import documentationReducer from './documentationSlice';
import enquiryReducer from './enquirySlice';
import salesReducer from './salesSlice';
import pageLoaderReducer from './pageLoaderSlice';
import sideMenuReducer from './sideMenuSlice';
import themeReducer from './themeSlice';
import topQuestionsReducer from './topQuestionSlice';
import trainingFilesReducer from './trainingFilesSlice';
import unansweredQuestionReducer from './unansweredQuestionSlice';
import userReducer from './userSlice';
import clientTeamsSlice from './clientTeamsSlice';
import regionReducer from './regionSlice';
import templatesReducer from './templatesSlice';
import sessionLogReducer from './sessionLogSlice';
import insightsReducer from './insightsSlice';
import userManualReducer from './userManualSlice';
import manualReducer from './manualSlice';
import campaignReducer from './campaignSlice';
import trainingVersionReducer from './trainingVersionSlice';
import beaconReducer from './beaconSlice';
import activeClientReducer from './activeClientSlice';
import agentWidgetReducer from './agentWidgetSlice';
import twilioCredentialReducer from './twilioCredentialSlice';
import queryFeedbackReducer from './queryFeedbackSlice';
import chatSidebarReducer from './chatSidebarSlice';
import webhookBuilderReducer from './webhookBuilderSlice';
import permissionsReducer from './permissionsSlice';
import rolesReducer from './rolesSlice';
import { RESET_STORE } from './resetStore';

const appReducer = combineReducers({
  permissions: permissionsReducer,
  roles: rolesReducer,
  manuals: userManualReducer,
  userManual: manualReducer,
  users: userReducer,
  leadsStats: leadsStatReducer,
  leads: leadsReducer,
  enquiry: enquiryReducer,
  enquiryTour: fetchEnquiryTourReducer,
  sales: salesReducer,
  clients: clientsReducer,
  clientTeams: clientTeamsSlice,
  training: trainingFilesReducer,
  darkMode: darkModeReducer,
  colorScheme: colorSchemeReducer,
  campaigns: campaignReducer,
  sideMenu: sideMenuReducer,
  theme: themeReducer,
  compactMenu: compactMenuReducer,
  pageLoader: pageLoaderReducer,
  controlCentre: controlCentreSliceReducer,
  clarionCalls: clarionCallsReducer,
  atlasSummary: atlasSummaryReducer,
  generalFilterSlice: generalFilterReducer,
  topQuestions: topQuestionsReducer,
  unansweredQuestions: unansweredQuestionReducer,
  visitorHistory: visitorsHistoryReducer,
  regions: regionReducer,
  templates: templatesReducer,
  sessionLog: sessionLogReducer,
  insights: insightsReducer,
  trainingVersions: trainingVersionReducer,
  beacon: beaconReducer,
  agentWidget: agentWidgetReducer,
  activeClient: activeClientReducer,
  twilioCredential: twilioCredentialReducer,
  queryFeedback: queryFeedbackReducer,
  documentation: documentationReducer,
  webhookBuilder: webhookBuilderReducer,
  chatSidebar: chatSidebarReducer,
});

const rootReducer: typeof appReducer = (state, action) =>
  action.type === RESET_STORE
    ? appReducer(undefined, action)
    : appReducer(state, action);

export const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;